module.exports = __webpack_public_path__ + "static/img/xlsx.b1667672.png";